export default {
  garage: {},
  credit: '',
  car_selected: {},
  load_garage: false,
  load_credit: false,
  credit_data:'',
  colecoes:{}
}
